import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "circle-bg" }
const _hoisted_5 = { class: "content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_ShareError = _resolveComponent("ShareError")
  const _component_Duplicate = _resolveComponent("Duplicate")
  const _component_ShareSkeleton = _resolveComponent("ShareSkeleton")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    blur: "",
    min_width: $options.size,
    max_width: $options.size
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["circle", {error: !!$data.error}])
              }, [
                _createVNode(_component_Icon, {
                  icon: "globe-02",
                  stroke: !!$data.error ? 'var(--brand-500)' : '#079455',
                  height: "2.4rem",
                  width: "2.4rem"
                }, null, 8 /* PROPS */, ["stroke"])
              ], 2 /* CLASS */)
            ])
          ]),
          _cache[1] || (_cache[1] = _createTextVNode(" Shared Conversation ")),
          _createVNode(_component_Icon, {
            class: "close pointer",
            disabled: $data.copying,
            icon: "x-close",
            width: "2rem",
            height: "2rem",
            stroke: "var(--gray-500)",
            onClick: _cache[0] || (_cache[0] = $event => ($options.goToChats()))
          }, null, 8 /* PROPS */, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          ($data.error)
            ? (_openBlock(), _createBlock(_component_ShareError, {
                key: 0,
                code: $data.error.http_code,
                onCancel: $options.goToChats
              }, null, 8 /* PROPS */, ["code", "onCancel"]))
            : (!!$data.owner)
              ? (_openBlock(), _createBlock(_component_Duplicate, {
                  key: 1,
                  owner: $data.owner,
                  copying: $data.copying,
                  onDuplicate: $options.duplicate,
                  onCancel: $options.goToChats
                }, null, 8 /* PROPS */, ["owner", "copying", "onDuplicate", "onCancel"]))
              : (_openBlock(), _createBlock(_component_ShareSkeleton, { key: 2 }))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["min_width", "max_width"]))
}